import { Heart, Briefcase, ShieldCheck, Home } from "lucide-react";

const POINTS = [
  {
    icon: Heart,
    title: "Convenience for seniors",
    desc: "Specialised geriatric care for elderly or bed-ridden family members — no painful trips to the clinic, no exhausting waits.",
  },
  {
    icon: Briefcase,
    title: "Time-saving for professionals",
    desc: "No more taking half-days off work. We visit on evenings, Saturdays and Sundays so dental care fits around your schedule.",
  },
  {
    icon: ShieldCheck,
    title: "Safe & hygienic",
    desc: "Hospital-grade sterilisation, autoclaved instruments and PPE kits for every visit — the same protocols as a top Pune clinic.",
  },
  {
    icon: Home,
    title: "Comfort of home",
    desc: "Ideal for children with dental anxiety, nervous patients, or anyone who simply prefers to be treated in their own space.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-20 md:py-28 bg-brand-bg" data-testid="why-choose-us">
      <div className="container-site">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden border border-brand-line shadow-lg">
              <img
                src="/why-blessing.jpg"
                alt="A caring hand holding an elderly patient's hand"
                loading="lazy"
                className="w-full h-[500px] object-cover"
              />
            </div>
            <div className="absolute lg:relative lg:-mt-14 lg:ml-8 bg-white rounded-2xl border border-brand-line shadow-md p-5 mt-6 max-w-sm">
              <p className="font-serif text-2xl text-brand-pine italic leading-snug">
                "A blessing for senior citizens."
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <p className="overline mb-3">Why choose home dental care</p>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-pine leading-tight">
              Built for the way <span className="italic text-brand-clay">Pune & PCMC families really live.</span>
            </h2>
            <p className="mt-5 text-brand-textMuted leading-relaxed max-w-xl">
              Whether it's an elderly parent who shouldn't travel, a working
              professional who can't take leave, or a child who's scared of the
              clinic — home dental care simply works better.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {POINTS.map((p, i) => (
                <div
                  key={p.title}
                  data-testid={`why-point-${i}`}
                  className="flex gap-4 p-5 rounded-2xl bg-white border border-brand-line/60"
                >
                  <div className="w-11 h-11 shrink-0 rounded-full bg-brand-clay/10 text-brand-clay flex items-center justify-center">
                    <p.icon size={20} strokeWidth={1.6} />
                  </div>
                  <div>
                    <h4 className="font-serif text-xl text-brand-pine">{p.title}</h4>
                    <p className="text-sm text-brand-textMuted mt-1 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
